module.exports = __webpack_public_path__ + "media/images/regional-image9-19ef4651aad58cb0c4ab5698d5c61856.jpg";